export const LOGO_LABEL = "GYAN RASHMI";
export const LOGO_SLOGAN = "SIKSHA SADAN";
export const ESTABLISH_YEAR = "1994";
export const CONTACT = "9955757210";
export const EMAIL = "info@gyanrashmi.org";
export const ADDRESS = "Sharda Nagar Bihiya Chaurasta Bhojpur - 802154";
